export const rescueManifest = {
    id: 'rescue',
    name: 'Rescue & Breakdown',
    description: 'Emergency vehicle recovery and roadside assistance — base price includes first 20 miles',
    version: '1.1.0',
    icon: 'Wrench',
    dependencies: ['maps', 'payments'],
    compatibleVehicles: ['towtruck'],
    allowedRoles: ['customer', 'driver', 'business', 'admin'],
    supportsB2B: true,
    b2bFeatures: {
        priorityLevels: ['standard', 'urgent', 'emergency'],
        fleetAssignment: 'nearest',
        autoDispatch: true,
        etaTracking: true,
    },
    pricing: {
        configurable: true,
        b2bConfigurable: true,
        fields: [
            { key: "vatRate", type: "percentage", label: "VAT Rate", hint: "UK VAT percentage applied to all charges", format: "percent", defaultValue: 0, min: 0, max: 100 },
            { key: 'basePrice', type: 'money', label: 'Base Price (incl. 20 miles)', hint: 'Base price that includes the first 20 miles (in pence)', format: 'pence', defaultValue: 12000, required: true },
            { key: 'includedMiles', type: 'number', label: 'Miles Included in Base', hint: 'Number of miles covered by the base price', format: 'number', defaultValue: 20, min: 0, required: true },
            { key: 'pricePerMile', type: 'money', label: 'Price per Extra Mile', hint: 'Charge per mile beyond included miles (in pence)', format: 'pence', defaultValue: 300, required: true },
            { key: 'minDistance', type: 'number', label: 'Minimum Distance (miles)', hint: 'Shortest trip distance to qualify', format: 'number', defaultValue: 1 },
            { key: 'urgentMultiplier', type: 'percentage', label: 'Urgent Multiplier', hint: 'Price multiplier for urgent priority dispatch', format: 'percent', defaultValue: 1.5, min: 1, max: 3 },
            { key: 'emergencyMultiplier', type: 'percentage', label: 'Emergency Multiplier', hint: 'Price multiplier for emergency/blue-light dispatch', format: 'percent', defaultValue: 2.5, min: 1, max: 5 },
            { key: 'nightSurcharge', type: 'money', label: 'Night Surcharge', hint: 'Flat surcharge for night-time call-outs (in pence)', format: 'pence', defaultValue: 5000 },
            { key: 'holidaySurcharge', type: 'money', label: 'Holiday Surcharge', hint: 'Flat surcharge for bank holiday call-outs (in pence)', format: 'pence', defaultValue: 8000 },
        ],
    },
    features: {
        requiresInventory: false,
        requiresPropertyType: false,
        allowsMultiDrop: false,
        requiresFloorInfo: false,
        hasAssemblyOption: false,
    },
};
//# sourceMappingURL=manifest.js.map